// lib
import moment from "moment";
// src
import { HOUR, DAY } from "config/constants";

const DEFAULT_WINDOW = 13 * HOUR;

export const newWindowRange = (action, start, endOrWindow) => {
  // action is TODAY, FOCUS, PREV or NEXT
  if (action === "FOCUS") {
    const duration = endOrWindow || DEFAULT_WINDOW;
    const newStart = moment(start).startOf("day").add(8, "h").valueOf();
    return [newStart, newStart + duration];
  }
  if (action === "TODAY") {
    const newStart = moment().startOf("day").add(8, "h").valueOf();
    return [newStart, newStart + DEFAULT_WINDOW];
  }
  let length = endOrWindow.getTime() - start.getTime();
  if (length === DEFAULT_WINDOW) length = DAY; // hack to move per day
  if (action === "PREV") {
    return [start.getTime() - length, endOrWindow.getTime() - length];
  }
  return [start.getTime() + length, endOrWindow.getTime() + length];
};
